export default __webpack_public_path__ + "static/media/dullingblow4.5bc2c2ff.png";